export default __webpack_public_path__ + "static/media/icon_arrow_right_small_round_white.a7ed7230.svg";